import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import InputValueProps from '../../../../../prop-types/input-value-props';
import { PARAMETER } from '../../../../../constants/parameter-name-for-update';
import style from './style.module.less';

const TextInput = ({ inputValueProps, onChange, label }) => {
  const { parameter } = inputValueProps;
  const [inputValue, setInputValue] = useState(parameter);
  const onSetInputValue = useCallback(
    (e) => {
      setInputValue(e?.target?.value);
    },
    [setInputValue],
  );

  const onValueChange = useCallback(
    (e) => {
      onChange({
        [PARAMETER]: e?.target?.value,
      });
    },
    [onChange],
  );

  return (
    <div className={style['multi-control-row']}>
      <div>{label}</div>
      <div>
        <input className={style['text-input']} onBlur={onValueChange} onChange={onSetInputValue} value={inputValue} />
      </div>
    </div>
  );
};

TextInput.propTypes = {
  inputValueProps: InputValueProps.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.node.isRequired,
};

export default TextInput;
